/**
 * Itens do menu principal, compartilhados pelo menu desktop (`app-header-main`) e pelo
 * menu mobile (`app-header-menu`). Use `route` para rotas internas e `href` para links
 * externos (abrem em nova aba).
 */
export interface NavItem {
  label: string;
  title?: string;
  route?: string;
  href?: string;
  children?: NavItem[];
}

const MANAGER = 'https://manager.pinpag.com.br/';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Quem somos', title: 'Sobre nós', route: '/quem-somos' },
  {
    label: 'Segmentos',
    route: '/',
    children: [
      { label: 'Despachantes', route: '/despachantes-documentalistas' },
      { label: 'Cartórios', route: '/cartorios' },
      { label: 'Área da Saúde', route: '/saude' },
      { label: 'Área da Educação', route: '/educacao' },
      { label: 'Oficina Mecânica', route: '/oficina-mecanica' },
      { label: 'Concessionárias', route: '/concessionarias' },
    ],
  },
  {
    label: 'Nossos serviços',
    route: '/',
    children: [
      { label: 'Bom Condutor', route: '/bom-condutor' },
      { label: 'Webdespachantes', href: 'https://www.webdespachantes.com.br/' },
      { label: 'Busca de parceiros', route: '/pdv' },
    ],
  },
  {
    label: 'Nossos produtos',
    route: '/',
    children: [{ label: 'Máquinas de Pagamento', route: '/maquininhas' }],
  },
  {
    label: 'Serviços',
    route: '/',
    children: [
      { label: 'Quanto Vendi', href: 'https://www.quantovendi.com.br/' },
      { label: 'Cartórios', href: MANAGER },
      { label: 'Despachantes e CFC', href: MANAGER },
      { label: 'Loja de veículos / Simulador', href: MANAGER },
    ],
  },
];

export const CLIENT_AREA_URL = 'https://clientes.pinpag.com.br';
export const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=551142237590';
